var map = {
	"./access-credentials.svg": "1416",
	"./alipay.svg": "1b1d",
	"./aliyun.svg": "1f36",
	"./amd.svg": "3a5b",
	"./apsara.svg": "77c3",
	"./arrow-right.svg": "206b",
	"./auth/password.svg": "4aba",
	"./auth/safety-certificate.svg": "2c33",
	"./auth/user-delete.svg": "1e6a",
	"./auth/user.svg": "345f",
	"./auto-set.svg": "5b62",
	"./aws.svg": "9f4f",
	"./azure.svg": "736c",
	"./baidu.svg": "acdd",
	"./bank-card.svg": "beca",
	"./bill-resource.svg": "dc11",
	"./bill-set-cny.svg": "fe0d",
	"./bill-set-usd.svg": "6caf",
	"./bingocloud.svg": "f5d3",
	"./blank.svg": "f339",
	"./caret-down.svg": "eebf",
	"./ceph.svg": "93dc",
	"./change-password.svg": "2a4a",
	"./checkbox-empty.svg": "a11e",
	"./checkbox-fill.svg": "5676",
	"./checkbox-some.svg": "4dc9",
	"./chinaunion.svg": "3a53",
	"./chrome.svg": "f4f8",
	"./close.svg": "86c2",
	"./cloud.svg": "3613",
	"./cloudpods.svg": "57c9",
	"./cloudshell.svg": "46a6",
	"./code.svg": "8e1d",
	"./copy.svg": "e67b",
	"./coupon.svg": "c55b",
	"./cpu.svg": "41ec",
	"./ctyun.svg": "63af",
	"./daping.svg": "07a7",
	"./dashboard-alert-sum.svg": "b994",
	"./dashboard-alerts-trend.svg": "9afa",
	"./dashboard-bill-number.svg": "9d44",
	"./dashboard-bill-pie.svg": "cc87",
	"./dashboard-bill-stack.svg": "df0f",
	"./dashboard-cloud-account-health.svg": "7ec6",
	"./dashboard-consmption-trend.svg": "381d",
	"./dashboard-consumption-percent.svg": "8098",
	"./dashboard-fee.svg": "2884",
	"./dashboard-log.svg": "efa9",
	"./dashboard-notice.svg": "68c2",
	"./dashboard-number.svg": "e1d5",
	"./dashboard-quota.svg": "cdaf",
	"./dashboard-resource-count.svg": "9134",
	"./dashboard-resource.svg": "f36e",
	"./dashboard-server-number.svg": "bd40",
	"./dashboard-suggest-detail.svg": "91a6",
	"./dashboard-suggest-overview.svg": "7f87",
	"./dashboard-title.svg": "a130",
	"./dashboard-top5.svg": "4df3",
	"./dashboard-trend.svg": "1e51",
	"./dashboard-usage.svg": "ad72",
	"./dashboard-user-info.svg": "719a",
	"./dashboard-vmhistory-count-trend.svg": "8228",
	"./data-empty.svg": "2c79",
	"./delete.svg": "6279",
	"./dimension.svg": "2fb4",
	"./dingtalk.svg": "f7f2",
	"./dollar.svg": "89ea",
	"./download.svg": "d9ae",
	"./draggable.svg": "e387",
	"./dstack.svg": "7bb2",
	"./ecloud.svg": "0690",
	"./email.svg": "3310",
	"./excel.svg": "741a",
	"./expand.svg": "b595",
	"./extdb.svg": "13c81",
	"./feishu.svg": "3b7d",
	"./gaokeyong.svg": "ff948",
	"./gold.svg": "96ff",
	"./google.svg": "866d",
	"./gpu.svg": "8499",
	"./h3c.svg": "44d4",
	"./hcs.svg": "ba86",
	"./hcso.svg": "fd36",
	"./hcsop.svg": "0c0d",
	"./help.svg": "8f85",
	"./hp.svg": "d652",
	"./huawei.svg": "66f8",
	"./icon_add.svg": "0773",
	"./icon_after_shutdown.svg": "9f1e",
	"./icon_ascent.svg": "977a",
	"./icon_baremetal.svg": "e455",
	"./icon_cloudsell.svg": "ffab",
	"./icon_cpu.svg": "fe68",
	"./icon_decline.svg": "bdd2",
	"./icon_dropdown.svg": "234c",
	"./icon_menu.svg": "55a1",
	"./icon_monitor.svg": "4c1c",
	"./icon_monitor_vnc.svg": "87d1",
	"./icon_more.svg": "3c5e",
	"./icon_next.svg": "dbf1",
	"./icon_notice.svg": "fd9a1",
	"./icon_off.svg": "3026",
	"./icon_open.svg": "7d4e",
	"./icon_optimization.svg": "4430",
	"./icon_ram.svg": "e3de",
	"./icon_reboot.svg": "248c3",
	"./icon_remote.svg": "369d",
	"./icon_running.svg": "6ef0",
	"./icon_search.svg": "9c1f",
	"./icon_shuttingdown.svg": "0d3d",
	"./icon_stop.svg": "b84f",
	"./icon_tenant.svg": "0a7b",
	"./icon_vnc.svg": "9f02",
	"./incloudsphere.svg": "2bb8",
	"./info.svg": "f534",
	"./info2.svg": "6781",
	"./integral.svg": "9eb6",
	"./jdcloud.svg": "3d06",
	"./k8s.svg": "b013",
	"./keypairs.svg": "d8ed",
	"./kongzhitai.svg": "3174",
	"./ksyun.svg": "3664",
	"./language.svg": "b59c",
	"./large-page-memory.svg": "aa09",
	"./loading.svg": "96ab",
	"./logo.svg": "bec4",
	"./menu-ai.svg": "c74f",
	"./menu-compute.svg": "cabb",
	"./menu-dashboard.svg": "81fd",
	"./menu-db.svg": "c8c3",
	"./menu-extdb.svg": "34b4",
	"./menu-helm.svg": "f2e0",
	"./menu-iam.svg": "76da",
	"./menu-k8s.svg": "bb41a",
	"./menu-meter.svg": "a4bc",
	"./menu-middleware.svg": "266a",
	"./menu-monitor.svg": "7a75",
	"./menu-multicloud.svg": "9551",
	"./menu-network.svg": "b00b",
	"./menu-operation.svg": "900d",
	"./menu-report.svg": "80d8",
	"./menu-setting.svg": "4b44",
	"./menu-storage.svg": "f99e",
	"./menu-suggest.svg": "c9cb",
	"./menu-tenant.svg": "0d4c",
	"./menu.svg": "0788",
	"./mobile.svg": "4d68",
	"./mongodb.svg": "d53b",
	"./more.svg": "13f3",
	"./move.svg": "fc15",
	"./navbar-more.svg": "d3bb",
	"./navbar-notify.svg": "a114",
	"./navbar-process.svg": "2940",
	"./navbar-project.svg": "5a18",
	"./navbar-setting.svg": "81ae",
	"./navbar-user.svg": "4139",
	"./navbar-view-switch.svg": "dcd8",
	"./nutanix.svg": "040b",
	"./nvidia.svg": "c484",
	"./onecloud-map.svg": "4bb1",
	"./onecloud.svg": "8afd",
	"./open.svg": "8efb",
	"./openshift.svg": "5159",
	"./openstack.svg": "36c2",
	"./oraclecloud.svg": "09d1",
	"./organization.svg": "55fc",
	"./passthrough.svg": "93f7",
	"./password.svg": "c6ec",
	"./pdf.svg": "a707",
	"./projectmapping.svg": "446f",
	"./proxmox.svg": "4859",
	"./pull-down.svg": "d9b9",
	"./qcloud.svg": "f284",
	"./qingcloud.svg": "da39",
	"./question.svg": "6af3",
	"./refresh.svg": "1529",
	"./remotefile.svg": "e6c3",
	"./res-access-group.svg": "2d78",
	"./res-backup-storage.svg": "9174",
	"./res-baremetal.svg": "394f",
	"./res-bastion-host.svg": "6dfd",
	"./res-billtask.svg": "65ff",
	"./res-blockstorage.svg": "9556",
	"./res-brand.svg": "d39d",
	"./res-broadcast.svg": "b295",
	"./res-bucket.svg": "7a611",
	"./res-cdn-domain.svg": "116a",
	"./res-cloudaccount.svg": "186a",
	"./res-cluster.svg": "50f8",
	"./res-commonalert.svg": "f23c",
	"./res-contact.svg": "19db",
	"./res-disk-backup.svg": "ff0d",
	"./res-disk-snapshot.svg": "dbbe",
	"./res-disk.svg": "311e",
	"./res-dns.svg": "235c",
	"./res-domain.svg": "01ee",
	"./res-dynamicschedtag.svg": "31f0",
	"./res-eip.svg": "c677",
	"./res-elasticsearch.svg": "69b1",
	"./res-file-system.svg": "85c6",
	"./res-flexnetwork.svg": "95a4",
	"./res-gpu.svg": "59b5",
	"./res-group.svg": "9b52",
	"./res-host.svg": "016c",
	"./res-identity-provider.svg": "7c68",
	"./res-image.svg": "0d6e",
	"./res-instance-backup.svg": "2ab8",
	"./res-instance-snapshot.svg": "4626",
	"./res-instancegroup.svg": "a72e",
	"./res-ip.svg": "acda",
	"./res-ipv6-gateway.svg": "e8db",
	"./res-k8s-chart.svg": "1b98",
	"./res-k8s-configmap.svg": "6fcc",
	"./res-k8s-cronjob.svg": "1e3a",
	"./res-k8s-daemonset.svg": "1ddb4",
	"./res-k8s-deployment.svg": "e54e",
	"./res-k8s-ingress.svg": "d102",
	"./res-k8s-job.svg": "2145",
	"./res-k8s-kubecluster.svg": "242b",
	"./res-k8s-kubecomponent.svg": "27a1",
	"./res-k8s-namespace.svg": "74f5",
	"./res-k8s-node.svg": "4cc9",
	"./res-k8s-persistentvolumeclaim.svg": "5e41",
	"./res-k8s-pod.svg": "b6e9",
	"./res-k8s-rbacclusterrole.svg": "f720",
	"./res-k8s-rbacclusterrolebinding.svg": "7dec",
	"./res-k8s-rbacrole.svg": "c59d",
	"./res-k8s-rbacrolebinding.svg": "7f3c",
	"./res-k8s-release.svg": "6850",
	"./res-k8s-repo.svg": "a1d9",
	"./res-k8s-secret.svg": "08de",
	"./res-k8s-service.svg": "b32a",
	"./res-k8s-serviceaccount.svg": "e88e4",
	"./res-k8s-statefulset.svg": "0596",
	"./res-k8s-storageclass.svg": "e7b2",
	"./res-kafka.svg": "eab0",
	"./res-keypair.svg": "b70d",
	"./res-kuaizhao.svg": "7906",
	"./res-kuaizhaocelue.svg": "f631",
	"./res-lb.svg": "a631",
	"./res-lbacl.svg": "e226",
	"./res-lbbackendgroup.svg": "f32b",
	"./res-lbcert.svg": "72e3",
	"./res-lblistener.svg": "e9f8",
	"./res-lblistenerrule.svg": "80d3",
	"./res-modelarts.svg": "e355",
	"./res-month.svg": "a840",
	"./res-mount-target.svg": "e25e",
	"./res-nat.svg": "70ef",
	"./res-network.svg": "9ea6",
	"./res-networkinterfaces.svg": "82e6",
	"./res-physicalmachine.svg": "cc66",
	"./res-policy.svg": "9638",
	"./res-policydefinition.svg": "cf57",
	"./res-project-sharing.svg": "098b",
	"./res-project.svg": "b9c4",
	"./res-proxysetting.svg": "c8a1",
	"./res-rate.svg": "27ce",
	"./res-rds-backup.svg": "1b985",
	"./res-rds.svg": "ae65",
	"./res-recovery.svg": "71f0",
	"./res-redis.svg": "c748",
	"./res-region.svg": "6258",
	"./res-repair-order-configuration.svg": "262e",
	"./res-report.svg": "95f2",
	"./res-resource-tag.svg": "e4ae",
	"./res-resourcetype.svg": "ff71",
	"./res-role.svg": "e56c",
	"./res-route-table.svg": "f013",
	"./res-saml-provider.svg": "40fb",
	"./res-scalinggroup.svg": "86ee",
	"./res-schedpolicy.svg": "1f1d",
	"./res-schedtag.svg": "babb",
	"./res-secgroup.svg": "53d8",
	"./res-servertemplate.svg": "5c39",
	"./res-servicecatalog.svg": "fc70",
	"./res-sku.svg": "44a7",
	"./res-smaluser.svg": "08eb",
	"./res-strategy.svg": "4e31",
	"./res-suggestsalert.svg": "e29c",
	"./res-suggestsrule.svg": "6923",
	"./res-tablestore.svg": "90f5",
	"./res-tag.svg": "5f6a",
	"./res-tapservice.svg": "465f",
	"./res-topic.svg": "cecd",
	"./res-user.svg": "312a",
	"./res-user2.svg": "7a45",
	"./res-vminstance.svg": "6402",
	"./res-vpc-network.svg": "6ccf",
	"./res-vpc-peer-connect.svg": "a269",
	"./res-vpc.svg": "b3de",
	"./res-webapp.svg": "dc52",
	"./res-wire.svg": "2c5d",
	"./res-zone.svg": "46e7",
	"./s3.svg": "8ea0",
	"./sangfor.svg": "2675",
	"./search.svg": "8e22",
	"./select-switch.svg": "d37f",
	"./setting.svg": "70ef2",
	"./ssh.svg": "b128",
	"./stars.svg": "8b92",
	"./start.svg": "6bba",
	"./switch.svg": "d0bc",
	"./theme-setting.svg": "645e",
	"./transfer.svg": "d81e",
	"./ucloud.svg": "aebe",
	"./up.svg": "6a8e",
	"./user-del.svg": "a53a",
	"./user.svg": "c588",
	"./vmware.svg": "2d50",
	"./volcengine.svg": "cc3e",
	"./waf.svg": "73b6",
	"./webconsole.svg": "c064",
	"./workwx.svg": "d2b4",
	"./xsky.svg": "41f2",
	"./zizhanghao.svg": "eda8",
	"./zstack.svg": "0a57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d7c7";